import React, { useState, useRef, useEffect } from 'react';
import { useForm } from "react-hook-form";
import {
    Paper, TextField, Box, Grid, Typography, TableCell, CardContent, TableContainer, Table, TableHead, Button, IconButton, FormControl,
    TableRow, TableBody, MenuItem, Snackbar, DialogContent
} from '@mui/material';
import { v4 as uuidv4 } from "uuid";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from '@iconify/react';
import CloseIcon from '@mui/icons-material/Close';
import { BootstrapDialog, BootstrapDialogTitle } from '../../reusableComponent/BootstrapDialog'
import { ERPinput } from '../../reusableComponent/ErpTextField';
import Breadcrumb from '../../reusableComponent/Breadcrumb';
import { StyledTableCell, StyledTableRow } from '../../reusableComponent/StyledTable';
import styles from '.././../../styles.module.css';
import { addTermsConditions, editDeleteTermsConditions, getTermsConditionsList } from '../../../actions/actions';
import { useDispatch, useSelector } from 'react-redux';
import { financialYear } from '../../reusableComponent/financialYear';
import { dateConversion, dateConversionOnEntryPageWithTime } from '../../reusableComponent/dateConversionOnEntryPage';
import { BackBtn } from '../../reusableComponent/BackBtn';


function ConditionsAdd(props) {
    const { handleSubmit } = useForm();
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    let navigate = useNavigate();
    const location = useLocation();
    const [isUpdateArray, setIsUpdateArray] = useState(false);
    const [terms, setTerms] = React.useState('Sales Invoice');
    const [successMessage, setSuccessMessage] = useState(null);

    const [inputFields, setInputFields] = useState(
        [{
            id: uuidv4(),
            termsAndConditions: '',
        }]
    );
    const termsList = useSelector(state => state.termsConditions.termsConditions)

    const handleChangeTerms = (event) => {
        const getSelectedValue = event.target.value;
        setTerms(getSelectedValue);
        dispatch(getTermsConditionsList({ companyId: userInfo.companyId, terms: getSelectedValue }));
    };

    const [shouldShowMsg, setShouldShowMsg] = useState(false);
    const responseMessage = useSelector(state => state.termsConditions.message);

    useEffect(() => {
        if (responseMessage) {
            setShouldShowMsg(true);
        }
    }, [responseMessage, dispatch]);

    useEffect(() => {
        if (shouldShowMsg) {
            if (responseMessage !== null) {
                setSuccessMessage(responseMessage);
                setShouldShowMsg(false);
                dispatch({ type: 'RESET_MESSAGE' }); // Dispatch an action to reset the message
            }
        }
    }, [shouldShowMsg, responseMessage]);


    const handleMultipleInput = (e, i) => {
        const array = inputFields;
        let result = array[i];
        result[e.target.name] = e.target.value;
        array[i] = result;
        setInputFields(array);
        setIsUpdateArray(isUpdateArray ? false : true);
    }

    const handleAddFields = () => {
        setInputFields([
            ...inputFields,
            {
                id: uuidv4(),
                termsAndConditions: '',
            },

        ]);
    };

    const handleRemoveFields = (id) => {
        const values = [...inputFields];
        values.splice(
            values.findIndex((value) => value.id === id),
            1
        );
        setInputFields(values);
    };

    useEffect(() => {
        if (termsList.length > 0) {
            const initialInputFields = termsList && termsList.map((r, index) => ({
                id: uuidv4(),
                termsAndConditions: r.termsAndConditions,
            }));
            setInputFields(initialInputFields);
        } else {
            setInputFields([{
                id: uuidv4(),
                termsAndConditions: '',
            }])
        }

    }, [termsList])

    const onSubmit = (event) => {
        let currDate = new Date();
        let currentYear = dateConversion(currDate)
        let conditionsData = {
            companyId: userInfo.companyId,
            terms: terms,
            inputFields: inputFields,
            createdBy: termsList.length > 0 ? termsList[0].createdBy : userInfo.userId,
            createdAt: termsList.length > 0 ? termsList[0].createdAt : dateConversionOnEntryPageWithTime(new Date()),
            modifiedBy: termsList.length > 0 ? userInfo.userId : null,
            modifiedAt: termsList.length > 0 ? dateConversionOnEntryPageWithTime(new Date()) : '',
        }
        if (termsList.length > 0) {
            dispatch(editDeleteTermsConditions(conditionsData));
        } else {
            dispatch(addTermsConditions(conditionsData));
        }
        setTerms('')
    }


    const handleCloseSuccessMsg = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSuccessMessage(false)
    };

    const actionMsg = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleCloseSuccessMsg}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    return (
        <>
           <Breadcrumb
                        routeSegments={[
                            { name: 'Masters', path: '/masters/' },
                            { name: 'Terms & Conditions' },
                        ]}
                    />
            <Paper className={`${styles.list_container}`}>
                <Box sx={{ m: 4}} > </Box>
                
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Box >
                        <Grid container spacing={0} >
                            <Grid item md={2}>
                                <Typography sx={{ fontSize: '12px', paddingLeft: '0px' }}>Document Type </Typography>
                            </Grid>
                            <Grid item md={3}>
                                <FormControl fullWidth>
                                    <ERPinput
                                        required
                                        name="terms"
                                        value={terms}
                                        size="small"
                                        onChange={handleChangeTerms}
                                        select
                                    >
                                        <MenuItem value="Sales Invoice" className={`${styles.erp_lable}`}>Sales Invoice </MenuItem>
                                        <MenuItem value="Proforma Invoice" className={`${styles.erp_lable}`}>Proforma Invoice </MenuItem>
                                        <MenuItem value="Purchase Order" className={`${styles.erp_lable}`}>Purchase Order </MenuItem>
                                        <MenuItem value="Quotation" className={`${styles.erp_lable}`}>Quotation</MenuItem>
                                    </ERPinput>
                                </FormControl>
                            </Grid>
                        </Grid>

                    </Box>
                    <br />
                    <Grid container spacing={0} >
                        <Grid item md={2}> </Grid>
                        <Grid item md={10}>
                        <TableContainer component={Paper} style={{ overflowY: 'auto', maxHeight: 320 }}>
                        <Table sx={{ minWidth: 900 }} size='small' stickyHeader>
                            <TableHead >
                                <StyledTableRow>
                                    {/* <TableCell className='tableHead'>Item COde</TableCell> */}
                                    <StyledTableCell className={`${styles.table_head}`} style={{ width: '35%', padding: "5px", fontWeight: "bold" }}>
                                        Terms And Conditions
                                    </StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.table_head}`}>Action</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {terms !== '' &&
                                    <>
                                        {inputFields.slice(0, 5) && inputFields.slice(0, 5).map((row, index) => {
                                            return (
                                                <StyledTableRow key={row.id} >
                                                    <StyledTableCell className={`${styles.list_table_body}`}>
                                                        <ERPinput
                                                            sx={{
                                                                width: { sm: 100, md: 800 },
                                                                "& .MuiInputBase-root": {
                                                                    "& input": {
                                                                        textAlign: "left",
                                                                        fontSize: '12px',
                                                                        textTransform: 'none',
                                                                        "&:hover": {
                                                                            backgroundColor: '#ffff'
                                                                        },
                                                                    }
                                                                }
                                                            }}
                                                            fullWidth
                                                            variant="standard"
                                                            InputProps={{
                                                                disableUnderline: true,
                                                            }}
                                                            required
                                                            name="termsAndConditions"
                                                            value={row.termsAndConditions}
                                                            onChange={(e) => handleMultipleInput(e, index)}

                                                        />
                                                    </StyledTableCell>

                                                    <StyledTableCell align="right" className={`${styles.list_table_body}`}>
                                                        <Box style={{ display: 'flex', justifyContent: 'right' }}>
                                                            <IconButton size="small" style={{ color: 'blue' }} onClick={handleAddFields}>
                                                                <Icon icon={'line-md:plus-circle'} />
                                                            </IconButton>
                                                            {index === 0 ?
                                                                <IconButton disabled size="small">
                                                                    <Icon icon={'line-md:remove'} style={{ fontSize: '12px' }} />
                                                                </IconButton> :
                                                                <IconButton size="small" onClick={() => handleRemoveFields(row.id)}>
                                                                    <Icon style={{ color: 'red', fontSize: '12px' }} icon={'line-md:remove'} />
                                                                </IconButton>
                                                            }
                                                        </Box>
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            );
                                        })}

                                    </>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                             </Grid>
                    </Grid>
                   

                    <Box sx={{ marginTop: '12px', float: 'right' }}>
                        {terms !== '' &&
                            <Button color="primary" id={`${styles.btn_save}`} variant="contained" type="submit">
                                {termsList.length > 0 ? 'Update' : 'Save'}
                            </Button>
                        }
                    </Box>
                </form>
                {successMessage &&
                    <Snackbar
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                        open={successMessage ? true : false}
                        autoHideDuration={1000}
                        onClose={handleCloseSuccessMsg}
                        message={successMessage}
                        action={actionMsg}
                    />
                }
            </Paper>
        </>
    )
}

export default ConditionsAdd;
